// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application";

import HelloController from "./hello_controller";
application.register("hello", HelloController);

import ThemeController from "./theme_controller";
application.register("theme", ThemeController);

import HeaderMenuController from "./header_menu_controller";
application.register("header-menu", HeaderMenuController);

import PasswordToggleController from "./password_toggle_controller";
application.register("password-toggle", PasswordToggleController);

import InstallPromptController from "./install_prompt_controller";
application.register("install-prompt", InstallPromptController);

import ReportFormController from "./report_form_controller";
application.register("report-form", ReportFormController);

import FinancialTransactionFormController from "./financial_transaction_form_controller";
application.register(
  "financial-transaction-form",
  FinancialTransactionFormController,
);

import CohortFormController from "./cohort_form_controller";
application.register("cohort-form", CohortFormController);
